import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.TERMINAL_MANAGEMENT_SYSTEM.GAB_MANAGEMENT.GLOBAL_SETTINGS_MENU;

const GlobalSettingsMenu: Array<LinkItemProps> = [
  {
    name: 'Groupe',
    link: URL.GROUP,
    level: 3,
  },
  {
    name: 'Groupe Fits',
    link: URL.FITS_GROUP,
    level: 3,
  },
  {
    name: 'Table  Instituts Financiers',
    link: URL.FINANCIAL_INSTITUTES_TABLE,
    level: 3,
  },
  {
    name: 'Valeurs FDK',
    link: URL.FDK_VALUES,
    level: 3,
  },
  {
    name: 'Dénomination',
    link: URL.DESIGNATION,
    level: 3,
  },
  {
    name: 'Configuration Impression',
    link: URL.PRINT_SETTING,
    level: 3,
  },
];

export default GlobalSettingsMenu;
